import { QuoteNoteType } from 'quotes/enums';
import { ICustomerQuote } from 'quotes/types';

export const getQuoteNoteContent = (quote: ICustomerQuote, type: QuoteNoteType) => {
  return quote?.notesMap[type]?.content || '';
};

export const getQuoteNoteId = (quote: ICustomerQuote, type: QuoteNoteType) => {
  return quote?.notesMap[type]?.id || null;
};
